import { render, staticRenderFns } from "./RankPanel.vue?vue&type=template&id=6a646d73&"
import script from "./RankPanel.vue?vue&type=script&lang=js&"
export * from "./RankPanel.vue?vue&type=script&lang=js&"
import style0 from "./RankPanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RankPanel.vue"
export default component.exports